<header>
  <nav>
    <app-horizontal-menu />
  </nav>
</header>
<main class="app-main">
  <router-outlet/>
</main>
<footer class="app-footer flex items-center justify-center">v{{ projectVersion() }}</footer>
